import {Injectable} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {MaterialSupplierGroup} from './material-supplier-group.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaterialSupplierGroupService {
  constructor(protected http: HttpClient) {
  }

  list(): Observable<MaterialSupplierGroup[]> {
    return this.http.get<MaterialSupplierGroup[]>(`${environment.apiv4uri}material/supplier/group/list`);
  }
}
